<template>
  <router-view/>
</template>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

p, ul, ol {
  margin: 0;
}

ul {
  padding-left: 1rem;
  list-style-type: disc;
}

li {
  margin: 5px 0;
}

ol {
  padding-left: 1.75rem;
}

@counter-style symbolic-first {
  system: symbolic;
  symbols: "1.1" "1.2" "1.3";
}

@counter-style symbolic-second {
  system: symbolic;
  symbols: "2.1" "2.2" "2.3" "2.4";
}

@counter-style symbolic-third {
  system: symbolic;
  symbols: "3.1" "3.2" "3.3";
}

@counter-style symbolic-fourth {
  system: symbolic;
  symbols: "4.1" "4.2" "4.3";
}

@counter-style symbolic-fifth {
  system: symbolic;
  symbols: "5.1" "5.2" "5.3";
}

@counter-style symbolic-sixth {
  system: symbolic;
  symbols: "6.1" "6.2";
}

@counter-style symbolic-seventh {
  system: symbolic;
  symbols: "7.1" "7.2";
}

@counter-style symbolic-eighth {
  system: symbolic;
  symbols: "8.1" "8.2";
}

.common {
  font-size: .9rem;
  padding: 0 .625rem env(safe-area-inset-bottom) .625rem;

  h4, h5 {
    margin: .5rem 0;
  }

  .first {
    list-style: symbolic-first;
  }

  .second {
    list-style: symbolic-second;
  }

  .third {
    list-style: symbolic-third;
  }

  .fourth {
    list-style: symbolic-fourth;
  }

  .fifth {
    list-style: symbolic-fifth;
  }

  .sixth {
    list-style: symbolic-sixth;
  }

  .seventh {
    list-style: symbolic-seventh;
  }

  .eighth {
    list-style: symbolic-eighth;
  }

  .memo {
    font-size: .8rem;
    color: #7a7979;
    margin-top: 10px;

    h5 {
      font-size: .9rem;
      font-weight: 400;
    }
  }
}
</style>
